import { type CanvasElementType } from '@blaze-runtime/engine-domain';
import { fromStyles } from '@blaze-shared/style-state-feature';
import { type StyleSheet } from '@blaze-shared/theming-domain';

export const getDefaultStyleSheet = (
  elementType: CanvasElementType,
  styleSheets: StyleSheet[],
): StyleSheet | undefined => {
  const globalDefault = styleSheets.find(
    (styleSheet) =>
      styleSheet.elementType === elementType && styleSheet.isDefault && !styleSheet.themeId,
  );
  const defaultInTheme = styleSheets.find(
    (styleSheet) =>
      styleSheet.elementType === elementType && styleSheet.isThemeDefault && styleSheet.themeId,
  );
  return defaultInTheme ?? globalDefault;
};

/**
 * Resolves the desired stylesheet for a new element by name,
 * optionally falling back to the default sheet for the element type.
 * @param elementType
 * @param styleSheets
 * @param desiredName
 * @param fallbackToDefault
 */
export function getStyleSheetForNewElement(
  elementType: CanvasElementType,
  styleSheets: StyleSheet[],
  desiredName?: string | null,
  fallbackToDefault = true,
): StyleSheet | undefined {
  const namedStyleSheet = desiredName
    ? fromStyles.findMatchingStyleSheet({ name: desiredName, elementType, sheets: styleSheets })
    : undefined;

  if (namedStyleSheet) {
    return namedStyleSheet;
  }

  return fallbackToDefault ? getDefaultStyleSheet(elementType, styleSheets) : undefined;
}
